import { render, staticRenderFns } from "./bindOrganizationalAccount.vue?vue&type=template&id=70c1d2de&scoped=true&"
import script from "./bindOrganizationalAccount.vue?vue&type=script&lang=js&"
export * from "./bindOrganizationalAccount.vue?vue&type=script&lang=js&"
import style0 from "./bindOrganizationalAccount.vue?vue&type=style&index=0&id=70c1d2de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c1d2de",
  null
  
)

export default component.exports